module.exports = __webpack_public_path__ + "img/cert19.60a9bf09.jpg";